import { ContactDataDisplayModelFormGroup } from '../../../../../api/models/ace/xFound/Portal/Core/CAQ/Models/contact-data-display-model';
import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { StateService } from '@/core/services/state.service';
import { ContactDataDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/contact-data-display-model';
import { AnfrageService } from '@/api/service-index';
import { LoadingAnimationService } from '@/core/services/loading-animation.service';
import { PortalContextService } from '@/core/services/portal-context.service';
import { SectionService } from '@/core/services/section.service';
import { AnfrageNavigationFormComponent, MoveDirection } from '../../../../components/anfrage-navigation-form/anfrage-navigation-form.component';
import { UnfinishedHttpMethodsService } from '@/core/services/unfinished-http-methods.service';
import { UpdateAnfrageAnsprechpersonDataCommand } from '@/api/model-index';

@Component({
    selector: 'ansprechperson-form-process-step',
    templateUrl: './ansprechperson-form-process-step.component.html',
    styleUrls: ['./ansprechperson-form-process-step.component.scss'],
    standalone: false
})
export class AnsprechpartnerFormProcessStepComponent extends AnfrageNavigationFormComponent {
    public contactDataProcessStepForm: ContactDataDisplayModelFormGroup;
    public contactData: ContactDataDisplayModel;

    public get formGroup(): FormGroup<any> {
        return this.contactDataProcessStepForm;
    }

    constructor(protected route: ActivatedRoute,
        protected router: Router,
        protected sectionService: SectionService,
        protected anfrageService: AnfrageService,
        protected stateService: StateService,
        protected portalContextService: PortalContextService,
        protected loadingAnimationService: LoadingAnimationService,
        protected unfinishedHttpMethodsService: UnfinishedHttpMethodsService) {

        super(sectionService, router, route, portalContextService);

        this.contactData = this.route.snapshot.data.contactData;
        this.contactDataProcessStepForm = ContactDataDisplayModelFormGroup.Instance

        this.contactDataProcessStepForm.patchValue(this.contactData);
    }

    protected save(shouldSave: boolean, moveDirection: MoveDirection): void {

        if (shouldSave && this.contactDataProcessStepForm.dirty) {
            this.contactData = this.contactDataProcessStepForm.getRawValue();

            if (this.contactDataProcessStepForm.CbweitererAnsprechpartner.value !== true) {
                this.contactData.cbweitererAnsprechpartner = false;
                delete this.contactData.weitererAnsprechpartner;
            }

            delete this.portalContextService.CurrentAnfrage.contactData;
            this.contactDataProcessStepForm.markAsPristine();

            let updateCommand = new UpdateAnfrageAnsprechpersonDataCommand()
            updateCommand.ansprechperson = this.contactData.ansprechpartner;
            updateCommand.weitereAnsprechperson = this.contactData.weitererAnsprechpartner;
            updateCommand.cbweitererAnsprechpartner = this.contactData.cbweitererAnsprechpartner;

            let subscription = this.anfrageService.apiAnfrageAnfrageIdContactDataAnsprechpersonPatch({ anfrageId: this.anfrage.id, body: updateCommand })
                .subscribe(() => {
                    this.anfrageService.apiAnfrageAnfrageIdContactDataGet({ anfrageId: this.anfrage.id }).subscribe(response => {
                        if (response) {
                            this.anfrageService.apiAnfrageAnfrageIdValidateGet({ anfrageId: this.anfrage.id }).subscribe(result => {
                                this.stateService.ValidationErrors = result;
                            })

                            if (this.portalContextService.CurrentAnfrage)
                                this.portalContextService.CurrentAnfrage.contactData = response;

                            this.contactDataProcessStepForm.patchValue(response);
                            this.contactDataProcessStepForm.markAsPristine();
                        }
                    });
                    
                    //move after successful save as the data is needed on VertretungsberechtigteFormProcessStepComponent
                    if (moveDirection != MoveDirection.STAY) {
                        if (this.canceledRoute) {
                            this.router.navigateByUrl(this.canceledRoute);
                        } else {
                            this.move(moveDirection);
                        }
                    }
                }, (error) => {
                    this.contactDataProcessStepForm.markAsDirty();
                    throw error;
                });
            this.loadingAnimationService.showSpinnerUsingSubscription(subscription);
            this.unfinishedHttpMethodsService.addSubscription(subscription);
        } else {
            this.contactDataProcessStepForm.markAsPristine();
            this.move(moveDirection);
        }
    }
}
